export default function SEOPageHero({ eyebrow, h1, intro, badges = [], updated, image, kpis = [] }) {
  return <section className="seo-rich-hero">
    <div className={image ? 'seo-hero-grid' : ''}>
      <div>{eyebrow && <p className="customer-eyebrow">{eyebrow}</p>}
        <h1 itemProp="headline">{h1}</h1>
        {intro && <p className="seo-hero-intro" itemProp="description">{intro}</p>}
        {!!badges.length && <ul className="seo-hero-badges">{badges.map((badge, i) => <li key={i}>{badge}</li>)}</ul>}
        {updated && <p className="seo-hero-date">Opdateret <time>{updated}</time> · Skrevet af enkel energi-redaktionen</p>}
      </div>
      {image && <img src={image} alt="" width="600" height="400" fetchPriority="high" decoding="async" />}
    </div>
    {!!kpis.length && <dl className="seo-hero-facts">{kpis.map((kpi, i) => <div key={i}><dt>{kpi.label}</dt><dd>{kpi.value}</dd></div>)}</dl>}
  </section>;
}